export enum UserFeatureFlags {
	IMPORT_EXPORT = 'IMPORT_EXPORT',
	CHAT_WIDGET = 'CHAT_WIDGET',
	GENERATE_DOCUMENT_IMAGE_CHUNKS = 'GENERATE_DOCUMENT_IMAGE_CHUNKS',
	CSV_FILE_CHUNKING_STRATEGY = 'CSV_FILE_CHUNKING_STRATEGY',
	USER_API_KEYS = 'USER_API_KEYS',
	AI_TOOLS = 'AI_TOOLS',
	MICROSOFT_TEAMS_INTEGRATION = 'MICROSOFT_TEAMS_INTEGRATION',
	CONNECT_MCP = 'CONNECT_MCP',
	TAXONOMY = 'TAXONOMY',
	DEEP_RESEARCH = 'DEEP_RESEARCH',
	STRIPE = 'STRIPE',
}

export enum AdminToolsFeatureFlags {
	COLLABORATION = 'COLLABORATION',
	PIPELINES = 'PIPELINES',
	CHAT_INSPECTOR = 'CHAT_INSPECTOR',
	MANAGE_USERS = 'MANAGE_USERS',
	SITEMAP_GENERATOR = 'SITEMAP_GENERATOR',
	IMPERSONATE = 'IMPERSONATE',
	UPDATE_LOGS = 'UPDATE_LOGS',
}

export enum AdminDashboardFeatureFlags {
	MANAGE_USERS = 'MANAGE_USERS',
	MANAGE_TEAMS = 'MANAGE_TEAMS',
	PLAN_AND_QUOTA = 'PLAN_AND_QUOTA',
	SEMANTIC_PROPERTY_MATCHER = 'SEMANTIC_PROPERTY_MATCHER',
}
